<template>
  <div>
    <div class="jumbotron">
      <div class="container marketing">
        <div class="row ">
          <div class="col-lg-8 col-xs-10"
               style="width:90%;background: #FFFFFF;padding:5%;border-radius: 5px;margin: 5%">
            <div>
              <el-row>
                <span><b>入库单：</b></span>
                <el-autocomplete
                    v-model="inRepositoryData.state"
                    label-width="auto"
                    :clearable='true'
                    :popper-append-to-body="false"
                    popper-class="el-autocomplete-suggestion"
                    :fetch-suggestions="querySearchAsync"
                    placeholder="请输入产品编号"
                    @select="handleSelect"
                ></el-autocomplete>
              </el-row>

              <div v-if="inRepositoryData.state" style="margin: 5px 0;font-size: 10px">
                <el-table
                    :data="tableData"
                    border
                    :header-cell-style="tableClass"
                    :row-style="tableinNumClass"
                    :cell-style="tableClass">
                  <el-table-column
                      width="auto"
                      prop="productNumber"
                      label="产品码">
                  </el-table-column>
                  <el-table-column
                      width="auto"
                      prop="productName"
                      label="产品名">
                  </el-table-column>
                  <el-table-column
                      prop="alreadyInNum"
                      width="auto"
                      label="已入库"
                  ></el-table-column>
                  <el-table-column
                      prop="inNum"
                      width="auto"
                      label="入库总数">
                  </el-table-column>
                </el-table>
              </div>


              <a-tabs v-model:activeKey="inRepositoryData.codeType" size="default">
                <a-tab-pane key="1" tab="直接入库"></a-tab-pane>
                <a-tab-pane key="2" tab="区间入库"></a-tab-pane>
              </a-tabs>

              <!--              码显示区-->
              <div style="min-height: 50px">
                <div style="margin: 15px" v-show="inRepositoryData.bigCodes.size>0">
                  <h5>大标</h5>
                  <ul>
                    <li v-for="item in inRepositoryData.bigCodes" :key="item">{{ item }}
                      <span style="margin-left: 25px;color: red" @click="delCode(item,'big')">删除</span>
                    </li>
                  </ul>
                </div>
                <div style="margin: 15px" v-show="inRepositoryData.midCodes.size>0">
                  <h5>中标</h5>
                  <ul>
                    <li v-for="item in inRepositoryData.midCodes" :key="item">{{ item }}
                      <span style="margin-left: 25px;color: red" @click="delCode(item,'mid')">删除</span>
                    </li>
                  </ul>
                </div>
                <div style="margin: 15px" v-show="inRepositoryData.smallCodes.size>0">
                  <h5>小标</h5>
                  <ul>
                    <li v-for="item in inRepositoryData.smallCodes" :key="item">{{ item }}
                      <span style="margin-left: 25px;color: red" @click="delCode(item,'small')">删除</span>
                    </li>
                  </ul>
                </div>
              </div>

              <el-row style="margin-top: 10px">
                <el-col :span="18">
                  <a-button type="primary" size="small" @click.native="scanCode">扫码</a-button>
                </el-col>
                <el-col :span="6">
                  <a-button size="small" type="primary" @click.native="inRepository">入库</a-button>
                </el-col>
              </el-row>
              <div style="margin-top: 20px;border-top: solid 1px #8b8b8b;padding-top: 10px">
              </div>
              <el-row>
                <el-col :span="12">
                  <span style="color: rgb(29, 142, 242)"><b>即将入库：</b>{{ willIn }}</span>
                </el-col>
                <el-col :span="12">
                  <span><b>剩余入库：</b>{{ willNeed }}</span>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {countInByCodes, getInRepositoryList, inRepository, postDataBind} from "../api/data_bind";
import {matchCode} from "../utils/matchCode";

export default {
  data() {
    return {
      bigLen: [],
      midLen: [],
      smallLen: [],
      restaurants: [],
      timeout: null,
      tableData: [],
      inRepositoryData: {
        state: '',
        selectRuKu: null,
        bigCodes: new Set(),
        midCodes: new Set(),
        smallCodes: new Set(),
        codeType: '1',
      },
      willIn: 0,
      willNeed: 0,
    };
  },
  watch: {
    "inRepositoryData": {
      handler: function () {
        this.$store.commit("setInRepositoryData", this.inRepositoryData)
      }
    },
  },
  created() {
    // 加载缓存
    if (this.$store.state.inRepositoryData) {
      this.inRepositoryData = this.$store.state.inRepositoryData
    }
    if (this.inRepositoryData.selectRuKu !== null) {
      this.willNeed = this.inRepositoryData.selectRuKu.inNum - this.inRepositoryData.selectRuKu.alreadyInNum - this.willIn
    }
    if (this.inRepositoryData.smallCodes.size +
        this.inRepositoryData.midCodes.size + this.inRepositoryData.bigCodes.size > 0) {
      this.countInByCodesApi()
    }
    if (this.inRepositoryData.state !== '') {
      this.tableData = []
      this.tableData.push(this.inRepositoryData.selectRuKu)
    }
    if (this.inRepositoryData.bigCodes.size === undefined) {
      this.inRepositoryData.bigCodes = new Set()
    }
    if (this.inRepositoryData.midCodes.size === undefined) {
      this.inRepositoryData.midCodes = new Set()
    }
    if (this.inRepositoryData.smallCodes.size === undefined) {
      this.inRepositoryData.smallCodes = new Set()
    }
    // 获取扫码数据
    this.bigLen = this.$store.state.codeLen.big
    this.midLen = this.$store.state.codeLen.mid
    this.smallLen = this.$store.state.codeLen.small
    if (this.$store.state.pre !== 'fromScan') {
      return
    }
    if (this.$store.state.code !== '') {
      this.freshCode()
    }
    this.$store.commit("setPre", '')
  },
  mounted() {
  },
  computed: {
    formItemLayout() {
      const {layout} = this.form;
      return layout === "horizontal"
          ? {
            labelCol: {span: 4},
            wrapperCol: {span: 14},
          }
          : {};
    },
    buttonItemLayout() {
      const {layout} = this.form;
      return layout === "horizontal"
          ? {
            wrapperCol: {span: 14, offset: 4},
          }
          : {};
    },
  },
  methods: {
    tableClass() {
      return 'font-size:12px;height:20px;padding:0;text-align:center;'
    },
    delCode(code, type) {
      let delOk = false
      switch (type) {
        case 'big':
        case '大':
          delOk = this.inRepositoryData.bigCodes.delete(code)
          break
        case 'mid':
        case '中':
          delOk = this.inRepositoryData.midCodes.delete(code)
          break
        case 'small':
        case '小':
          delOk = this.inRepositoryData.smallCodes.delete(code)
          break
        default:
          return
      }
      if (delOk) {
        this.countInByCodesApi()
      }
      this.$store.commit("setInRepositoryData", this.inRepositoryData)
      this.$forceUpdate()
    },
    querySearchAsync(queryString, cb) {
      var params = {}
      if (queryString !== '') {
        params = {productNumber: queryString}
      }
      getInRepositoryList(params).then((res) => {
        if (res.code == 200) {
          this.restaurants = []
          for (const i in res.data.list) {
            let d = res.data.list[i]
            d['value'] = d.inNo + '(' + d.productNumber + d.productName + ')'
            this.restaurants.push(d)
          }
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            cb(this.restaurants);
          }, 300);
        }
      });
    },
    handleSelect(item) {
      this.inRepositoryData.selectRuKu = item
      this.$store.commit("setInRepositoryData", this.inRepositoryData)
      this.tableData = []
      this.tableData.push(item)
      this.willNeed = this.inRepositoryData.selectRuKu.inNum - this.inRepositoryData.selectRuKu.alreadyInNum - this.willIn
    },
    scanCode() {
      if (this.inRepositoryData.state === '') {
        this.$message.error('请选择入库单');
        return
      }


      if (this.$store.state.isDev) {
        this.$store.commit("setScanCode", "89898991")
        this.freshCode()
        return;
      } else {
        this.$router.push({
          path: '/scanCodePage'
        });
      }

    },
    freshCode() {
      const c = this.$store.state.code;
      this.recordCode(c)
      this.$forceUpdate()
      this.$store.commit("setInRepositoryData", this.inRepositoryData)
    },
    recordCode(code) {
      const codeName = matchCode(code, this.bigLen, this.midLen, this.smallLen)
      if (codeName === '无效') {
        this.$message.error("长度不符合要求，无效码" + code)
        return
      }
      if (codeName === '大') {
        const before = this.inRepositoryData.bigCodes.size
        this.inRepositoryData.bigCodes.add(code)
        if (this.inRepositoryData.bigCodes.size === before) {
          this.$message.error("重复扫码" + code)
          return
        }

      }
      if (codeName === '中') {
        const before = this.inRepositoryData.midCodes.size
        this.inRepositoryData.midCodes.add(code)
        if (this.inRepositoryData.midCodes.size === before) {
          this.$message.error("重复扫码" + code)
          return
        }

      }
      if (codeName === '小') {
        const before = this.inRepositoryData.smallCodes.size
        this.inRepositoryData.smallCodes.add(code)
        if (this.inRepositoryData.smallCodes.size === before) {
          this.$message.error("重复扫码" + code)
          return
        }
      }
      this.countInByCodesApi()
    },
    countInByCodesApi() {
      if (this.inRepositoryData.smallCodes.size + this.inRepositoryData.midCodes.size + this.inRepositoryData.bigCodes.size <= 0) {
        return;
      }
      let mySet = new Set()
      if (this.inRepositoryData.codeType === '2') {
        if (this.inRepositoryData.bigCodes.size === 2) {
          mySet = this.inRepositoryData.bigCodes
        } else if (this.inRepositoryData.midCodes.size === 2) {
          mySet = this.inRepositoryData.midCodes
        } else if (this.inRepositoryData.smallCodes.size === 2) {
          mySet = this.inRepositoryData.smallCodes
        } else {
          return
        }
      }
      let myArray = Array.from(mySet);
      let from = ''
      let to = ''
      if (myArray.length === 2) {
        from = myArray.reduce((min, current) => min < current ? min : current)
        to = myArray.reduce((max, current) => max > current ? max : current)
      }

      const params = {
        "from_number": from,
        "to_number": to,
        "big_number": Array.from(this.inRepositoryData.bigCodes),
        "mid_number": Array.from(this.inRepositoryData.midCodes),
        "small_number": Array.from(this.inRepositoryData.smallCodes),
        "in_id": this.inRepositoryData.selectRuKu.id,
        "product_number": this.inRepositoryData.selectRuKu.productNumber
      }
      countInByCodes(params).then((res) => {
        if (res.code == 200) {
          if (this.willIn === res.data) {
            this.$message.error(this.$store.state.code + " 无效")
            this.delCode(this.$store.state.code, matchCode(this.$store.state.code, this.bigLen, this.midLen, this.smallLen))
            return
          }
          this.willIn = res.data
          this.willNeed = this.inRepositoryData.selectRuKu.inNum - this.inRepositoryData.selectRuKu.alreadyInNum - this.willIn
        }
      });
    },
    inRepository() {
      if (this.inRepositoryData.bigCodes.size === 2) {
        this.distanceIn()
      } else {
        this.allIn()
      }
      this.$forceUpdate()
    },
    distanceIn() {
      let mySet
      if (this.inRepositoryData.bigCodes.size === 2) {
        mySet = this.inRepositoryData.bigCodes
      } else if (this.inRepositoryData.midCodes.size === 2) {
        mySet = this.inRepositoryData.midCodes
      } else if (this.inRepositoryData.smallCodes.size === 2) {
        mySet = this.inRepositoryData.smallCodes
      } else {
        this.$message.error("请先扫出两个区间码")
        return
      }
      let myArray = Array.from(mySet);
      // 比较两个元素的大小，将小的值赋值给 from，大的值赋值给 to
      const params = {
        "from_number": myArray.reduce((min, current) => min < current ? min : current),
        "to_number": myArray.reduce((max, current) => max > current ? max : current),
        "in_id": this.inRepositoryData.selectRuKu.id,
        "product_number": this.inRepositoryData.selectRuKu.productNumber
      }
      this.inRepositoryApi(params);
    },
    allIn() {
      if (this.inRepositoryData.bigCodes.size === 0 && this.inRepositoryData.midCodes.size === 0 && this.inRepositoryData.smallCodes.size === 0) {
        this.$message.error("请先扫码")
        return
      }
      const params = {
        "from_number": "",
        "to_number": "",
        "big_number": Array.from(this.inRepositoryData.bigCodes),
        "mid_number": Array.from(this.inRepositoryData.midCodes),
        "small_number": Array.from(this.inRepositoryData.smallCodes),
        "in_id": this.inRepositoryData.selectRuKu.id,
        "product_number": this.inRepositoryData.selectRuKu.productNumber
      }
      this.inRepositoryApi(params);
    },
    inRepositoryApi(params) {
      inRepository(params).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.inRepositoryData = {
            state: '',
            selectChuKu: null,
            bigCodes: new Set(),
            midCodes: new Set(),
            smallCodes: new Set(),
            codeType: this.inRepositoryData.codeType,
          }
          this.$store.commit("setInRepositoryData", this.inRepositoryData)
          location.reload()
        }
      });
    }


  },
}
;
</script>
<style scoped>
.marketing {
  margin-top: 50px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}

/deep/ .el-input {
  width: 220px;
  font-size: 11px;
}

::v-deep .el-autocomplete-suggestion {
  min-width: 200px;
  width: auto !important;
}

/deep/ .el-table .el-table__cell {
  padding: 1px;
  min-width: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
  text-align: left;
}

</style>